import { useState } from 'react'
import ReactPlayer from 'react-player'
import styled from 'styled-components'
import Button from '../shared/Button'
import { useIsBrowserAgent } from '../../helpers/hooks'
import styles from '../../utility/styles'

const Wrapper = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
`

const StyledPlayer = styled(ReactPlayer)`
	max-height: 100dvh;
	& > video {
		max-height: 100dvh;
		@media screen and ${styles.breakpoints.desktop} {
			max-height: calc(100dvh - 75px);
		}
		@media screen and (max-width: 798px), screen and (max-height: 450px) {
			max-height: 100dvh;
		}
	}
`

const CloseButton = styled(Button)`
	position: absolute;
	right: 32px;
	padding: 12px;
	border-radius: 24px;
	margin: -24px -24px 0 0;
	display: ${({ visible }) => visible ? 'block' : 'none'};
	transition: 0.5s;
`

/**
 *
 * @param {{source:string}} props
 * @returns
 */
export default function ZapVideo({ source, close }) {
	const [top, setTop] = useState('')
	const isIPhone = useIsBrowserAgent('iPhone')
	const onReady = () => {
		const wrapper = document.getElementById('wrapper')?.clientHeight
		const video =
			document.getElementById('video')?.firstElementChild?.clientHeight
		const nudge = isIPhone ? 60 : 32
		const diff = (wrapper - video) / 2 + nudge
		if (!Number.isNaN(diff)) {
			setTop(`calc(env(safe-area-inset-top) + ${diff}px)`)
		} else {
			setTop('32px')
		}
	}

	return (
		<Wrapper id='wrapper'>
			<StyledPlayer
				playing
				playsinline
				{...{ onReady }}
				id='video'
				url={source}
				width='100%'
				height='auto'
				controls
			/>
			<CloseButton variant='secondary' onClick={close} style={{ top }} visible={!!top}>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='24'
					height='24'
					viewBox='0 0 24 24'
					fill='none'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.27566 4.27566C3.90811 4.64322 3.90811 5.23914 4.27566 5.60669L10.1984 11.5294L4.27566 17.4521C3.90811 17.8197 3.90811 18.4156 4.27566 18.7832C4.64322 19.1507 5.23914 19.1507 5.60669 18.7832L11.5294 12.8604L17.5859 18.9169C17.9535 19.2845 18.5494 19.2845 18.9169 18.9169C19.2845 18.5494 19.2845 17.9535 18.9169 17.5859L12.8604 11.5294L18.7832 5.60669C19.1507 5.23914 19.1507 4.64322 18.7832 4.27566C18.4156 3.90811 17.8197 3.90811 17.4521 4.27566L11.5294 10.1984L5.60669 4.27566C5.23914 3.90811 4.64322 3.90811 4.27566 4.27566Z'
						fill='white'
					/>
				</svg>
			</CloseButton>
		</Wrapper>
	)
}
